<template>
  <div class="home">
    <el-image :src="header"></el-image>
    <div class="serach">
      <div class="title">{{ row.activityTitle }}</div>
      <div class="orange">
        活动时间：{{ row.startDate }} 至 {{ row.endDate }}
      </div>
      <div class="input-buttom">
        中奖查询:
        <el-input
          :placeholder="`请输入订单编号`"
          size="small"
          v-model.trim="nickNameOrOrderNo"
          clearable
          class="inputWidthHeader"
        >
          <template slot="append">
            <el-button @click="rankingDetails">查询</el-button>
          </template>
        </el-input>
      </div>

      <div class="textHeader" v-if="moreOptions">
        {{ tableDataList && tableDataList[0] ? tableDataList[0].activitySubject : '' }}
      </div>
      <div class="textHeader" v-if="!moreOptions">
        {{  tableDataList[0] && tableDataList[0].activitySubject ? tableDataList[0].activitySubject.slice(0, 50) : '' }}
      </div>
      <div class="moreText">
        <el-button type="text" @click="more"
          >{{ moreOptions ? "收起" : "查看更多" }}
          <i
            :class="[moreOptions ? 'el-icon-arrow-up' : 'el-icon-arrow-down']"
          ></i>
        </el-button>
      </div>
      <!-- activitySubject -->
      <div v-for="(item, index) in tableDataList" :key="index">
        <div class="grey">{{ item.activityType }}</div>
        <div class="tableBox">
          <el-table
            :header-cell-style="{ 'text-align': 'center' }"
            :data="item.detailList"
            border
            ref="myTable"
            :row-style="{ height: '32px' }"
            :cell-style="{ padding: '0', 'text-align': 'center' }"
          >
            <el-table-column
              prop="rankingNumber"
              label="排名"
              width="80"
            ></el-table-column>
            <!-- <el-table-column
              v-if="!storeName.includes('TM')"
              prop="customerNickName"
              label="买家名称"
              min-width="100"
              show-overflow-tooltip
            ></el-table-column> -->
            <el-table-column
              prop="orderNo"
              label="订单编号"
              min-width="160"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              prop="payTime"
              label="支付时间"
              min-width="160"
              show-overflow-tooltip
            ></el-table-column>
            <!-- <el-table-column prop="accumulatedAmount" label="累计金额" show-overflow-tooltip></el-table-column> -->
            <el-table-column
              prop="discount"
              label="优惠"
              min-width="130"
              show-overflow-tooltip
            ></el-table-column>
          </el-table>
        </div>
        <div
          class="tableDownText"
          v-if="item.detailList && item.detailList.length >= 10 && (item.total ? item.total > item.detailList.length : true )"  
          @click="tableDataSeach(item, index)"
        >
          查看更多
        </div>
      </div>
    </div>
    <div class="footer">
      <el-image :src="footer" class="imgSize"></el-image>
      <div @click="$router.go(-1)">返回上一页</div>
    </div>
  </div>
</template>
<script>
import header from "../../assets/images/header.png";
import footer from "../../assets/images/logo.png";
export default {
  name: "Home",
  data() {
    return {
      header: header,
      footer: footer,
      input1: "",
      tableDataList: [],
      nickNameOrOrderNo: "",
      searchForm: {},
      row: {},
      moreOptions: false,
      moreOptionsIndex: 1,
      storeName: ''
    };
  },
  mounted() {
    this.row = this.$route.query;
    this.storeName = this.row.storeName;
    this.rankingDetails();
  },
  methods: {
    rankingDetails() {
      // if(!this.nickNameOrOrderNo) return
      this.tableDataList = []
      let data = {
        activityTitle: this.row.activityTitle,
        storeName: this.row.storeName,
        nickNameOrOrderNo: this.nickNameOrOrderNo,
        fileId: this.row.fileId
      };
      this.$api.lotteryQuery.rankingDetails(data).then((res) => {
        console.log("------", res.data);
        this.tableDataList = res.data.map((item) => {
          return {
            ...item,
            pageNum: 1,
            pageSize: 10,
          };
        });
      });
    },
    more() {
      this.moreOptionsIndex += 1;
      if (this.moreOptionsIndex % 2 == 0) {
        this.moreOptions = true;
      } else {
        this.moreOptions = false;
      }
    },
    tableDataSeach(row, index) {
      let data = {
        ...this.row,
        activityType: row.activityType,
        pageNum: row.pageNum,
        pageSize: row.pageSize + 10,
      };
      this.$api.lotteryQuery.rankingDetailsType(data).then((res) => {
        console.log("------", res.data);
        this.tableDataList[index].detailList = res.data.records
        this.tableDataList[index].pageSize = res.data.pageSize
        this.tableDataList[index].total = res.data.total
      });
    },
  },
};
</script>
<style lang="stylus" scoped>
.home {
  width: auto;
  height: 100%;
  overflow-y: auto;
  background: #fff;

  .serach {
    padding-top: 71px;
    width: 70%;
    margin: 0 auto;
    text-align: center;

    .title {
      text-align: center;
      font-size: 60px;
      font-weight: 600;
      color: #2B2B2B;
    }
  }

  .footer {
    width: 70%;
    margin: 0 auto;
    text-align: center;
    padding: 122px 0 50px 0;

    div {
      margin-top: 34px;
      font-size: 18px;
      color: #2B2B2B;
      font-weight: 600;
      cursor: pointer;
    }
  }
}

.inputWidthHeader {
  width: 324px;
}

.moreText {
  text-align: left;
}

.orange {
  color: #F41715;
  font-size: 24px;
  margin-top: 21px;
  margin-bottom: 30px;
}

.input-buttom {
  margin-bottom: 64px;
}

.black {
  color: #FD6434;
}

.grey {
  text-align: left;
  color: #2B2B2B;
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 20px;
}

.input-buttom >>> .el-input__inner {
  border: 1px solid #F72F1D;
}

.moreText >>> .el-button {
  padding: 5px 0 15px 0;
}

.moreText >>> .el-button--text {
  color: #f72f1d;
}

>>> .el-input__inner:focus {
  border-color: #F05239;
}

>>> .el-input-group__append, .el-input-group__prepend {
  background: linear-gradient(185deg, #EF3231, #FF6B31);
  color: #FFFFFF;
  border: 1px solid #f72f1d;
}

>>> .tableBox {
  margin-bottom: 20px;
}

>>> .el-table {
  border-radius: 4px;
  border-top: 1px solid #D7D7D7;
  border-left: 1px solid #D7D7D7;
  border-right: 1px solid #D7D7D7;
  border-bottom: 1px solid #D7D7D7;
}

>>> .el-table .el-table__header th {
  background: #f05239 !important;
  height: 2.5rem;
  color: #FFFFFF;
}

.textHeader {
  color: #9B9B9B;
  white-space: pre-line;
  text-align: left;
  padding-left: 5p;
}

.tableDownText {
  color: #9b9b9b;
  cursor: pointer;
}
</style>
<style scoped>
@media screen and (max-width: 1000px) {
  * {
    font-size: 12px;
  }
  /* ios滚动卡顿问题 */
  .home {
    -webkit-overflow-scrolling: touch;  
  }
  /* ios滚动卡顿问题 */
  .home div {
    -webkit-transform: translateZ(0px);
  }
  .home .serach {
    width: 100%;
    margin: 0 auto;
    padding-top: 15px;
    text-align: center;
  }
  .home .serach .title {
    text-align: center;
    font-size: 22px;
    font-weight: 600;
    color: #2b2b2b;
  }
  .inputWidthHeader {
    width: 61%;
  }
  .grey {
    padding-left: 5px;
    font-size: 16px;
    margin-bottom: 10px;
  }
  .orange {
    font-size: 14px;
    margin-bottom: 20px;
  }
  .home .footer {
    margin: 0 auto;
    text-align: center;
    padding: 30px 0 30px 0;
  }
  .imgSize {
    width: 200px;
    height: 50px;
  }
  .tableDownText {
    margin-bottom: 20px;
  }
  .home .footer div {
    margin-top: 15px;
    font-size: 14px;
    color: #2b2b2b;
    font-weight: 600;
    cursor: pointer;
  }
  .textHeader {
    padding: 0 5px;
  }
  .moreText {
    padding-left: 5px;
  }
}
</style>